var layout_default = {
  "layout": "JRZzL",
  "cell": "_-8-LY"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
